import React from 'react';
import {
  useReactTable,
  createColumnHelper,
  getCoreRowModel,
} from '@tanstack/react-table';

import { formatNumberToInternational } from "../../../../utils/utils";


const App = (props) => {
  
  const { columnsData, tableData, tableName, onActionClick
   } = props;

  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.group({
      header: 'CLASSIFICAÇÃO ORÇAMENTÁRIA',
      columns: [
        columnHelper.group({
          header: 'NATUREZA DA DESPESA',
          columns: [
            columnHelper.accessor('codigo', {
              header: 'CÓDIGO',
              cell: info => ( <div style={{ textAlign: 'left' }}>
                {info.getValue()}
              </div>),
            }),
            columnHelper.accessor('descricao', {
              header: 'DESCRIÇÃO',
              cell: info => (
                <div style={{ textAlign: 'left' }}>
                  {info.getValue()}
                </div>
              ),
            }),
            
          ],
        }),
        columnHelper.accessor('uo', {
          header: 'UO',
          cell: info => info.getValue(),
        }),
        columnHelper.accessor('fr', {
          header: 'FR',
          cell: info => info.getValue(),
        }),
        columnHelper.accessor('pat', {
          header: 'P/AT',
          cell: info => info.getValue(),
        }),
      ],
    }),

    columnHelper.group({
      header: 'MOEDAS',
      columns: [
        columnHelper.accessor('local', {
          header: 'LOCAL',
          columns: [
            columnHelper.accessor('jpy', {
              header: 'YJP',
              cell: info => (
                <div style={{ textAlign: 'right' }}>
                  {info.getValue() ? formatNumberToInternational(info.getValue()) : ''} 
                  
                </div>
              ),
            }),
          ],
        }),
        columnHelper.accessor('outras', {
          header: 'OUTRAS',
          columns: [
            columnHelper.accessor('usd', {
              header: 'USD',
              cell: info => (
                <div style={{ textAlign: 'right' }}>
                  {info.getValue() ? formatNumberToInternational(info.getValue()) : ''} 
                  {/* Format if value exists, else leave blank */}
                </div>
              ),
            }),
            columnHelper.accessor('eur', {
              header: 'EUR',
              cell: info => (
                <div style={{ textAlign: 'right' }}>
                   {info.getValue() ? formatNumberToInternational(info.getValue()) : ''} 
                </div>
              ),
            }),
          ],
        }),
      ],
    }),
    columnHelper.accessor('akz', {
      header: 'KWANZAS',
      columns: [
        columnHelper.accessor('akz', {
          header: 'AKZ',
          cell: info => (
            <div style={{ textAlign: 'right' }}>
               {info.getValue() ? formatNumberToInternational(info.getValue()) : ''} 
            </div>
          ),
        }),
      ],
    }),
  ];

  const table = useReactTable({
    data : tableData,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div>
      <table
        border="1"
        style={{
          borderCollapse: 'collapse',
          width: '100%',
          border: '1px solid black', // Outer black border
        }}
      >
        <thead>
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header, index) => (
                <th
                  key={header.id}
                  colSpan={header.colSpan}
                  style={{
                    padding: '4px',
                    textAlign: 'center',
                    fontSize: '14px',
                    backgroundColor: '#f0f0f0',
                    borderBottom: '1px solid #000', // Bottom border between header and body
                    borderRight: index < headerGroup.headers.length - 1 ? '1px solid #000' : '', // Vertical separator between columns
                  }}
                >
                  {header.isPlaceholder ? null : header.column.columnDef.header}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map(row => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell, index) => (
                <td
                  key={cell.id}
                  style={{
                    padding: '4px',
                    fontSize: '12px',
                    textAlign: 'center',
                    borderBottom: '1px solid #000', // Line between rows
                    borderRight: index < row.getVisibleCells().length - 1 ? '1px solid #000' : '', // Vertical separator between columns
                  }}
                >
                  {cell.column.columnDef.cell?.(cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default App;
